import React, { useContext } from 'react';
import { TERMS_OF_USE_TABS } from '../../config/routerLocations';
import { RoutingContext } from '../../context/routingContext';
import { DataProcessingAgreementPage } from '../data-processing-agreement/DataProcessingAgreementPage';
import { TermsOfUsePage } from './TermsOfUsePage';

// Data Processing Agreement Page is only for IBDs inside DXF.
// To skip creating configuration into First Spirit internal router
// is created for already established route- /terms-of-use
export const TermsOfUseRouterPage = () => {
  const { isLoaded, activeTab, setTab } = useContext(RoutingContext);

  React.useEffect(() => {
    if (isLoaded && !activeTab) {
      setTab(TERMS_OF_USE_TABS.TERMS_OF_USE);
    }
  }, [isLoaded, activeTab]);

  switch (activeTab) {
    case TERMS_OF_USE_TABS.TERMS_OF_USE:
      return <TermsOfUsePage />;
    case TERMS_OF_USE_TABS.DATA_PROCESSING_AGREEMENT:
      return <DataProcessingAgreementPage />;
    default:
      return <TermsOfUsePage />;
  }
};
